import React from 'react';
import { PopoverChevron, PopoverContent, type PopoverTypes } from '@fiverr-private/popover';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { Box } from '@fiverr-private/theme';
import { Container } from '@fiverr-private/layout_components';
import type { EducationTooltipContentProps, EducationTooltipVariant } from '../types';
import { useEducationTooltipContext } from '../EducationTooltipContext';

type VariantProps = Pick<PopoverTypes.PopoverContentProps, 'backgroundColor' | 'disableBoxShadow'>;
const variantSettings: Record<EducationTooltipVariant, VariantProps> = {
  white: {
    backgroundColor: 'white',
    disableBoxShadow: false,
  },
  default: {
    backgroundColor: 'blue_700',
    disableBoxShadow: true,
  },
};

const EducationTooltipContent = ({
  children,
  appendToBody = false,
  closeOnClickOutside = true,
}: EducationTooltipContentProps) => {
  const { onClose, variant } = useEducationTooltipContext();

  return (
    <PopoverContent
      appendToBody={appendToBody}
      closeOnClickOutside={closeOnClickOutside}
      disablePadding
      disableAutoFocus
      zIndex="educationTooltip"
      animationType="slideFade"
      borderRadius="lg"
      {...variantSettings[variant]}
    >
      <PopoverChevron size="sm" />
      <Box
        role="tooltip"
        padding="4"
        maxWidth={variant === 'white' ? 350 : 296}
        boxSizing="borderBox"
        color={variant === 'white' ? 'bodyPrimary' : 'white'}
        fontSize="b_md"
        lineHeight="b_md"
      >
        {children}
        <Container as="footer" display="flex" justifyContent="flexEnd" paddingTop="4">
          {variant === 'white' ? (
            <Button onClick={onClose} size="sm">
              <I18n k="education_tooltip.confirmButtonText" />
            </Button>
          ) : (
            <Box
              as="button"
              borderWidth={0}
              background={'none'}
              fontWeight="bold"
              fontSize="b_sm"
              lineHeight="b_sm"
              color="white"
              onClick={onClose}
            >
              <I18n k="education_tooltip.confirmButtonText" />
            </Box>
          )}
        </Container>
      </Box>
    </PopoverContent>
  );
};

EducationTooltipContent.displayName = 'EducationTooltipContent';

export default EducationTooltipContent;
